import { LayoutContainer } from '@pendwa/common-browser/components/LayoutContainer/index.js';
import { LayoutPageSection } from '@pendwa/common-browser/components/LayoutPageSection/index.js';
import { LoadingPage } from '@pendwa/common-browser/components/Loading/LoadingPage/index.js';
import { Suspense, lazy } from 'react';

const Default = lazy(() => import('./Default.js'));

export function Screen() {
  return (
    <Suspense
      fallback={
        <LayoutPageSection>
          <LayoutContainer>
            <LoadingPage />
          </LayoutContainer>
        </LayoutPageSection>
      }
    >
      <Default />
    </Suspense>
  );
}
